const getWindow = (): Window | undefined => (
  typeof window !== 'undefined' ? window : undefined
);

const preferSecureUrl = (candidate: string | undefined, insecurePrefix: string): string | undefined => {
  if (!candidate) return undefined;
  return String(candidate).startsWith(insecurePrefix) ? undefined : candidate;
};

export function getApiBase(): string {
  const envApi = typeof import.meta !== 'undefined' ? (import.meta as any).env?.VITE_API_URL : undefined;
  const win = getWindow();
  const isHttps = win?.location.protocol === 'https:';

  if (isHttps) {
    if (envApi) {
      return preferSecureUrl(envApi, 'http://') || win.location.origin;
    }
    return win?.location.origin || 'https://localhost';
  }

  if (envApi) return envApi;

  const hostname = win?.location.hostname || 'localhost';
  return `http://${hostname}:8081`;
}

export function getWebSocketBase(): string {
  const envWs = typeof import.meta !== 'undefined' ? (import.meta as any).env?.VITE_WS_URL : undefined;
  const win = getWindow();
  const isHttps = win?.location.protocol === 'https:';

  if (isHttps) {
    return preferSecureUrl(envWs, 'ws://') || `wss://${win.location.host}/ws`;
  }

  if (envWs) return envWs;

  const hostname = win?.location.hostname || 'localhost';
  return `ws://${hostname}:8080`;
}
